/**
 * Tests if the provided value is a string.
 * @param value - the value to test
 */
export const isString = value =>
  typeof value === 'string' || (typeof value === 'object' && value.constructor.name === 'String');
